<template>
  <div>
    <v-container fluid class="white pl-0 pr-0" :class="{ 'hero-background-retina': $vuetify.breakpoint.mdAndDown, 'hero-background': $vuetify.breakpoint.lgAndUp}">
      <v-layout row wrap>
        <v-flex xs12 sm6 md7 offset-xl2 xl4>
          <v-layout align-left justify-center column fill-height>
            <div :class="{'margin-144': $vuetify.breakpoint.mdAndUp, 'text-xs-center': $vuetify.breakpoint.smAndDown, 'pr-5': $vuetify.breakpoint.mdAndUp }">
              <h1 class="font-64 light-navy book">Už máš diář?</h1>
              <pink-line :style="pinkMargin"/>
                <h2 class="light-navy book font-24 py-3 primary--text" :class="{'px-1': $vuetify.breakpoint.xs}">
                    Kup si diář, zvládni všechny výzvy a vyplň formulář, ve kterém si vybereš vyzyvatele, se kterým se chceš setkat.
                </h2>
                <h2 class="light-navy book font-24 py-3" :class="{'px-1': $vuetify.breakpoint.xs}">
                    Připravili jsme pro vás diář s výzvami z oblastí: <br />
                    <span class="thin">pohybu, výživy, psychohygieny, vzdělání a prevence. Myslete na své zdraví a pojďte do toho s námi.</span>
                </h2>
              <v-btn color="#ed79ac" @click.stop="openModal('youtube')" large class="ml-0 regular font-24" dark>
                <div class="line-height">Koukni na video</div>
                <v-icon class="pl-4 margin-zero" large>play_circle_outline</v-icon>
              </v-btn>
              <v-btn flat href="https://shop.sifty.eu/" target="_blank" large class="regular font-24 hospital-green-text">
                <div class="line-height">
                  Koupit diář
                </div>
              </v-btn>
            </div>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 md5 xl6>
          <div class="py-5">
            <div class="hero-note">
              <div class="form pt-5 pl-5">
                <div class="pt-3 pl-3">
                    <!-- Begin Mailchimp Signup Form -->
                    <div id="mc_embed_signup" :style="'width: ' + formWidth">
                        <v-form id="form" ref="form" @submit="submit($event)" :action="'https://sifty.us19.list-manage.com/subscribe/post?u=159712ead54077bbc170c5870&id=' + mailChimpUrl" method="post">
                            <v-text-field
                                    label="Jméno"
                                    name="FNAME"
                                    class="regular mt-0"
                                    v-model="form.firstName"
                                    :rules="[rules.required]"
                            ></v-text-field>
                            <v-text-field
                                    label="Příjmení"
                                    name="LNAME"
                                    class="regular mt-0"
                                    v-model="form.lastName"
                                    :rules="[rules.required]"
                            ></v-text-field>
                            <v-text-field
                                    label="Věk"
                                    name="MMERGE3"
                                    class="regular mt-0"
                                    v-model="form.age"
                                    :rules="[rules.required]"
                            ></v-text-field>
                            <v-text-field
                                    label="Email"
                                    name="EMAIL"
                                    class="regular mt-0"
                                    v-model="form.email"
                                    :rules="[rules.required, rules.email]"
                            ></v-text-field>
                            <v-select
                                    :items="challengersSelect"
                                    label="Vyzyvatel"
                                    class="regular mt-0"
                                    v-model="form.challenger"
                                    :rules="[rules.required]"
                            ></v-select>
                            <v-checkbox
                                    label="Souhlasím s podmínkami o zpracování osobních údajů  v souvislosti s nařízením EU o ochraně osobních údajů"
                                    class="regular font-12 pt-0 mt-0"
                                    color="primary"
                                    v-model="form.consent"
                                    :rules="[rules.required]"
                            ></v-checkbox>
                            <v-checkbox
                                label="Chci dostávat nejnovější informace ze světa Sifty"
                                class="regular font-12 pt-0 mt-0"
                                color="primary"
                                v-model="form.marketing"
                            ></v-checkbox>
                            <div id="mc_embed_signup_scroll">
                                <div style="position: absolute; left: -5000px;" aria-hidden="true">
                                    <label>
                                        <input type="text" name="b_159712ead54077bbc170c5870_1d03111eac" tabindex="-1" value=""/>
                                    </label>
                                </div>
                            </div>
                            <input type="hidden" name="MMERGE4" :value="form.challenger">
                            <input type="hidden" name="MMERGE5" :value="boolToInt(form.marketing)">
                            <input type="hidden" name="MMERGE6" :value="boolToInt(form.consent)">
                            <v-btn color="info" :loading="loading" class="regular font-20" @click="submit($event)" block>Odeslat</v-btn>
                        </v-form>
                    </div>
                    <!--End mc_embed_signup-->
                    <v-snackbar
                            v-model="snackbar"
                            :multi-line="true"
                            :right="false"
                            :timeout="6000"
                            :top="false"
                            color="primary"
                    >
                        Potvrzení o přihlášení do soutěže jsme odeslali na Váš email, prosíme, zkontrolujte složky hromadné a nevyžádané pošty.
                    </v-snackbar>
                    <v-snackbar
                            v-model="snackbarError"
                            :multi-line="true"
                            :right="false"
                            :timeout="6000"
                            :top="false"
                            color="primary"
                    >
                       Tento email je již zaregistrován. Zkontrolujte složky hromadné a nevyžádané pošty.
                    </v-snackbar>
                </div>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="max-py">
        <v-layout row wrap class="text-xs-center">
          <v-flex xs12 class="pb-5">
              <img src="/static/about-logo.png" srcset="/static/about-logo@2x.png 2x" />
          </v-flex>
          <v-flex xs10 offset-xs1 sm8 offset-sm2>
              <div class="regular font-24 light-grey">
                Cílem <span class="strong">#Sifty52</span> je upozornit na to, jak mohou drobné změny životního stylu a každodenní rutiny významně ovlivnit mnohé aspekty našeho zdraví a přispět k prevenci řady onemocnění. Základem je mít srozumitelné a ověřené informace.
              </div>
              <div class="regular font-24 light-grey pt-3">
                <span class="strong">#Sifty52</span> je projektem neziskové organizace Sifty 52, z.s., která usiluje o zvýšení zdravotní gramotnosti a informovanosti v ČR.<br />Více o nás zjistíte&nbsp;<a href="https://sifty.eu/o-sifty/" target="_blank">zde</a>.
              </div>
          </v-flex>
        </v-layout>
    </v-container>
      <v-container fluid class="challenge-background white pl-0 pr-0" id="challengeOfTheWeek">
          <v-container class="max-py">
              <v-layout>
                  <v-flex xs12 sm10 offset-sm1>
                      <v-layout row wrap :class="{'text-xs-center': $vuetify.breakpoint.smAndDown }" v-if="currentYear == '2019'">
                          <v-flex xs12 sm12 md4 class="text-xs-center">
                              <img :src="'/static/v-' + challengeOfTheWeek.type + '.png'" :srcset="'/static/v-' + challengeOfTheWeek.type + '@2x.png 2x'" :style="imageMaxWidth" class="pb-3" v-if="!challengeOfTheWeek.challenger" />
                              <challenger-card v-else :challenger="challengeOfTheWeek.challenger" />
                          </v-flex>
                          <v-flex xs12 sm12 md8 class="px-5">
                              <div>
                                  <h2 class="book font-48 light-navy">Výzva na tento týden</h2>
                                  <short-line :style="greyMargin"/>
                                  <p class="regular font-24 light-grey pt-3">
                                    {{ challengeOfTheWeek.text }}
                                  </p>
                                  <v-btn color="#ed79ac" large class="ml-0 regular font-24" dark href="https://www.sifty.eu" target="_blank">
                                      <div class="line-height">Chci vědět víc</div>
                                  </v-btn>
                              </div>
                          </v-flex>
                      </v-layout>
                      <v-layout row wrap v-else>
                          <v-flex xs12 class="text-xs-center">
                              <h2 class="book font-48 light-navy">První výzva začíná 1. 1. 2019.</h2>
                          </v-flex>
                      </v-layout>
                  </v-flex>
              </v-layout>
          </v-container>
      </v-container>
      <v-container class="text-xs-center max-py" id="challengers">
          <h2 class="book font-48 light-navy">Vyzyvatelé</h2>
          <short-line />
          <v-flex xs12 offset-md2 md8>
          <p class="regular menu-text light-grey pt-3">
              Naši vyzyvatelé a vyzyvatelky jsou z řad špičkových sportovců a odborníků z oblastí výživy i neurovědy. Každý z nich si pro tebe připravil v rámci Sifty52 vlastní výzvu i parádní odměnu! Vydrž celý rok výzev a vyber si, s kým z nich chceš strávit den cvičením, povídáním a učením. Budeš-li chtít soutěžit o lekce a jiné ceny nad rámec této velké roční odměny, sleduj naše sociální média. Sem tam se totiž o něco soutěžit bude.
          </p>
          </v-flex>
          <v-layout row wrap align-center justify-center fill-height class="pt-5">
              <v-flex xs12 sm6 md4 lg3 v-for="(item,index) in challengers" :key="index" class="pb-2" :class="{'pr-2': $vuetify.breakpoint.smAndUp}">
                  <challenger-card :challenger="item" />
              </v-flex>
          </v-layout>
      </v-container>
      <v-container class="challenge-background max-py text-xs-center" id="ambasadors">
          <h2 class="book font-48 light-navy">Ambasadoři</h2>
          <short-line />
          <v-flex xs12 offset-md2 md8>
          <p class="regular menu-text light-grey pt-3">
              Jsme moc rádi, že máme tak skvělé podporovatele z nejrůznějších oborů a že zájem
              o zdraví i zdravotnictví neklesá. Děkujeme! Mrkněte kdo všechno se k nám přidal!
          </p>
          </v-flex>
          <div class="pt-4 text-xs-center vueCarousel">
              <carousel
                      :per-page="carouselPerPage"
                      :paginationEnabled="true"
                      paginationColor="#F8BBD0"
                      paginationActiveColor="#ed79ac"
              >
                  <slide v-for="ambasador in ambasadors" :key="ambasador.id">
                      <challenger :item="ambasador" :show-bio="true"/>
                  </slide>
              </carousel>
          </div>
      </v-container>
      <v-dialog persistent :value="youtubeModal">
            <youtube-modal @closed="closeModal"></youtube-modal>
      </v-dialog>
  </div>
</template>

<script>
  import PinkLine from '../components/PinkLine'
  import ShortLine from '../components/ShortLine'
  import { Carousel, Slide } from 'vue-carousel';
  import Challenger from '../components/Challenger'
  import ChallengerCard from '../components/ChallengerCard'
  import YoutubeModal from '../modals/YoutubeModal'
  import { mapMutations } from 'vuex'

  export default {
    components: {
        PinkLine,
        ShortLine,
        Carousel,
        Slide,
        Challenger,
        ChallengerCard,
        YoutubeModal
    },
    computed: {
      youtubeModal () {
        return this.$store.state.modals.youtube;
      },
      pinkMargin () {
        return this.$vuetify.breakpoint.smAndDown ? 'margin: 0 auto;' : 'margin: 0;'
      },
      greyMargin () {
        return this.$vuetify.breakpoint.smAndDown ? 'margin: 0 auto;' : 'margin: 0;'
      },
      imageMaxWidth () {
        return this.$vuetify.breakpoint.smAndDown ? 'max-width: 20%' : 'max-width: 100%'
      },
      carouselPerPage () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 1
          case 'sm': return 2
          case 'md': return 3
          case 'lg': return 4
          case 'xl': return 4
        }
      },
        formWidth() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return '250px'
                case 'sm': return '300px'
                case 'md': return '300px'
                case 'lg': return '300px'
                case 'xl': return '300px'
            }
        },
      options () {
        return {
          offset: -50
        }
      },
      ambasadors () {
        return this.$store.state.ambasadors;
      },
      challengers () {
        return this.$store.state.availableChallengers;
      },
      challengersSelect () {
        return this.$store.state.challengersSelect;
      }
    },
    mounted () {
      let query = this.$router.currentRoute.query;
      if (Object.keys(query).length !== 0 && query.constructor === Object) {
        if (query.hasOwnProperty('success')) {
          this.snackbar = true;
        }

        if (query.hasOwnProperty('scrollTo') && query.scrollTo !== '') {
          this.$vuetify.goTo('#' + query.scrollTo, this.options)
        }
      }
console.log(this.currentYear)
      this.getWeek();
    },
    methods: {
      ...mapMutations([
        'handleModal',
      ]),
        boolToInt(item) {
            return item ? 1 : 0;
        },
      getWeek() {
        let query = this.$router.currentRoute.query;
        if (Object.keys(query).length !== 0 && query.constructor === Object) {
          if (query.hasOwnProperty('week') && query.week !== '') {
            this.challengeOfTheWeek = this.$store.state.weekChallenges[query.week - 1];
            return;
          }
        }
          let date = new Date();
          date.setHours(0, 0, 0, 0);
          // Thursday in current week decides the year.
          date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
          // January 4 is always in week 1.
          let week1 = new Date(date.getFullYear(), 0, 4);
          // Adjust to Thursday in week 1 and count number of weeks from date to week1.
          let weekNumber = 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
            - 3 + (week1.getDay() + 6) % 7) / 7);
          this.challengeOfTheWeek = this.$store.state.weekChallenges[weekNumber - 1];
      },
      closeModal(update) {
        this.handleModal(update.type);
      },
      submit(event) {
        this.loading = true;
        event.preventDefault();
        if (this.$refs.form.validate()) {
            window.axios.get(process.env.API_URL + '/checkMailChimp?email=' + this.form.email).then(
                response => this.onUserFound()
            ).catch(
                error => document.getElementById('form').submit()
            )
        } else {
          this.loading = false;
        }
      },
        onUserFound() {
          this.loading = false;
            this.snackbarError = true;
        },
      openModal(modal, data) {
        this.handleModal(modal);
        this.$root.$emit(modal, data);
      },
    },
    data () {
      return {
        currentYear: (new Date()).getFullYear(),
        challengeOfTheWeek: {},
        snackbar: false,
        snackbarError: false,
        mailChimpUrl: process.env.MAILCHIMP_URL,
        rules: {
          required: value => !!value || 'Tuto hodnotu potřebujeme.',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Toto není správný email.'
          },
        },
        loading: false,
        form: {
          firstName: '',
          lastName: '',
          age: '',
          email: '',
          challenger: '',
          consent: false,
          marketing: false
        }
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Index.vue